<template>
    <div id="ProgramList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Program List</div>
                    <div class="btn-groups pull-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="importProgramsModal()" >
                            <i class="fp-import"></i> Import Programs
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import Asset
                        </a>
                        <router-link v-if="canAddProgram" class="btn btn-primary" v-bind:to="{name: 'ProgramCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content program-list">
                        <data-table-filter-config :moduleName="'programList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'programList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listProgramTable"
                                    mode="remote"
                                    title="Program"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateProgram">
                                                    <router-link title="Edit Program" class="fp-edit mr-3" v-bind:to="{name: 'ProgramEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                                <router-link title="Activity" class="fp-contracts" v-bind:to="{name: 'ProgramActivityCreate',params:{id:props.row.id},query:{fromUrl:fromUrl}}"></router-link>
                                            </div>
                                            <div v-if="props.column.field == 'name'">
                                                    <router-link title="View Program Asset" class="color-blue" v-bind:to="{name: 'ProgramAssetMapperList',params:{id:props.row.id}}">{{props.row.name}}</router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button id="addAssetBtn" v-on:click.prevent="addAsset('asset')" class="btn btn-primary">Add Asset</button>
                                        <button id="addAssetBtn" v-on:click.prevent="addAsset('group')" class="btn btn-primary">Add Asset Group</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        <div class="modal fade policy-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Select File</h5>
              </div>
              <div class="modal-body">
                <form id="importFile" class="addinspectionForm">
                  <div class="form-row">
                    <div class="col form-group">
                      <label class="control-label require mb-2" for="name">File:</label><br/>
                      <input id="typeImage" type="file" @change="onFileChanged">
                      <div class="field-error">{{import_error}}</div>
                    </div>
                  </div>
                  <!-- <hr class="light-hr"/> -->
                  <div class="form-row">
                    <div class="col form-group" v-if="fileName != ''">
                      <label class="control-label"> Download Sample file </label>
                      <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-excel color-gray"></i> {{fileName}} </a>
                    </div>
                  </div>
                  <!-- <p>&nbsp;</p> -->
                  <p>&nbsp;</p>
                  <template v-if="duplicateRecords.unit && duplicateRecords.unit.length > 0">
                      <label class="d-block"> Asset Not Imported Because These Unit Not Available:</label>
                      <template v-for="(asset,assetKey) in duplicateRecords.unit">
                          <a :key="assetKey" v-if="assetKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="assetKey">{{asset.unit_number}}</span>
                      </template>
                      <p>&nbsp;</p>
                  </template>
                  <template v-if="duplicateRecords.program && duplicateRecords.program.length > 0">
                      <label class="d-block"> Asset Not Imported Because Program Not Available:</label>
                      <template v-for="(program,pgmKey) in duplicateRecords.program">
                          <a :key="pgmKey" v-if="pgmKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="pgmKey">{{program.program}}</span>
                      </template>
                      <p>&nbsp;</p>
                  </template>
                </form>
              </div>
              <div class="modal-footer">
                <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                <button class="btn btn-primary" id="importButton" v-on:click="importAssetToProgram()"> <i class="fp-import"> </i> Import</button>
              </div>
            </div>
          </div>
        </div>

        <!-- program import feature -->
        <div class="modal fade programs-import-modal" id="programs-import-modal" ref="programs-import-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="programs-import-modal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Select File</h5>
                    </div>
                    <div class="modal-body">
                        <form id="importIFTAFile" class="addinspectionForm">
                            <div class="form-row">
                                <div class="col form-group">
                                    <label class="control-label require mb-2" for="name">File:</label><br/>
                                    <input id="programsUploadFile" type="file" @change="onFileChangedPrograms">
                                    <div class="field-error">{{programsImportError}}</div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col form-group" v-if="programsFileName != ''">
                                    <label class="control-label"> Download Sample file </label>
                                    <a href="javascript:void(0)" v-on:click="downloadProgramsImportSample()"> <i class="fp-text-document"></i> {{programsFileName}} </a>
                                </div>
                            </div>

                            <p v-if="programsImportedCount > 0"><i class="fa fa-check" aria-hidden="true"></i> &nbsp;<strong>{{programsImportedCount}} Records imported</strong></p> 
                        </form>

                        <div class="modal-footer">
                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                            <button class="btn btn-primary" id="importButton" v-on:click="programImport()"> <i class="fp-import"> </i> Import</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ProgramList",
        metaInfo() {
            return {title: "Program List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Description',
                    field: 'description',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Start Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'End Date',
                    field: 'end_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "End Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Type',
                    field: 'type',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            term_value: false,
            loading:false,
            canUpdateProgram:false,
            canAddProgram:false,
            fromUrl:"",
            duplicateRecords:[],
            selectedFile:"",
            import_error:'',
            fileName:'',
            file:'',
            selectedPrgFile:"",
            programsImportedCount:0,
            programsImportError:'',
            programsFileName:'',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_program') {
                            self.cantAccessPage = true;
                        }
                        // if (permissions[i].name == 'delete_Program') {
                        //     self.term_value = true;
                        // }
                        if (permissions[i].name == 'add_program') {
                            self.canAddProgram = true;
                            self.canUpdateProgram = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
            self.fromUrl = btoa(window.location.pathname);
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listProgramTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/program/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'program-list')
                    }
                });
            },

            addAsset:function(flag){
                var self = this;
                var data = self.$refs['listProgramTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listProgramTable'].selectedRows[i].id)
                }
                if(use.length > 1){
                    self.$swal('','Please Select Atmost One Program','info');
                    return;
                }

                if (flag == 'asset'){
                    self.$router.push("/asset/list?from=program&pr="+use[0]);
                }
                if (flag == 'group'){
                    self.$router.push("/assetgroup/list?from=program&pr="+use[0]);
                }
            },

            openModal: function(){
                var self = this;
                console.log(self.selectedFile);
                self.selectedFile = "";
                self.duplicateRecords = [];
                $("#typeImage").val('');
                self.import_error = '';

                $.ajax({
                    url:
                    process.env.ROOT_API + "/asset-program-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        self.loading = false;
                        console.log(data);
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'permit-import')

                    }
                });

                $('#myModal').modal('show');
            },

            onFileChanged (event) {
                const file = event.target.files[0]
                console.log(event.target);
                var self = this;
                self.selectedFile = file;
                console.log(self.selectedFile);
                self.import_error = '';
            },

            downloadSample(){
                var self = this;
                // alert(self.file);
                // console.log()
                var docPath = self.file;
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            importAssetToProgram: function(){

                var self = this;
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $.ajax({
                    url: process.env.ROOT_API + "/asset-program/import",
                    type: "POST",
                    // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {

                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        self.import_error = '';
                        self.loading = false;
                        if ( data.code == 201 ) {
                            self.import_error = data.message;
                            return;
                        }
                        if ( data.status == "success") {

                            self.$swal('',data.content.added+" records have been imported, "+ data.content.deleted +" records has been deleted" ,'success');
                            if ( Object.keys(data.duplicate).length > 0) {

                                self.duplicateRecords = data.duplicate;

                            } else {
                                
                                self.error = "";
                                $('#myModal').modal('hide');
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-import-error')
                    }
                });
            },
            importProgramsModal: function(){
                let self = this;
                self.programsImportedCount = 0;
                self.selectedPrgFile = "";
                $("#programsUploadFile").val('');
                self.programsImportError = '';
                self.generateProgramsExcelSample();
                $('#programs-import-modal').modal('show');
            },
            onFileChangedPrograms(event) {
                const file = event.target.files[0];
                let self = this;
                self.selectedPrgFile = file;
                self.programsImportError = '';
            },
            generateProgramsExcelSample() {
                let self = this;
                $.ajax({
                    url:
                    process.env.ROOT_API + "/programs-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    success: function(data) {
                        self.loading = false;
                        self.programsFileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'programs-upload-generate')

                    }
                });
            },
            downloadProgramsImportSample(){
                let self = this;
                let docPath = self.file;
                let save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            programImport() {
                let self = this;
                self.programsImportError = "";
                
                if( self.selectedPrgFile == "" || self.selectedPrgFile == null){
                    self.programsImportError = "Please Select Excel File.";
                    return;
                }
                let fileExtension = ['xls', 'xlsx'];
                if ($.inArray(self.selectedPrgFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                    self.programsImportError = "Only formats are allowed : "+fileExtension.join(', ');
                    return;
                }

                let formData = new FormData();
                formData.append('myFile', self.selectedPrgFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/programs-excel/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.programsImportError = '';
                        if (data.code == 400) {
                            self.programsImportError = data.message;
                            return;
                        }
                        if (data.status == "success") {
                            if ( Object.keys(data.duplicate).length > 0){
                                self.programsImportedCount = data.content;
                            }else{
                                if(data.content){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                $('#programs-import-modal').modal('hide');
                                self.loadList();
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'programs-upload-import-error')
                    }
                });
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ProgramList.vue